module.exports = __webpack_public_path__ + "9661e83f6ab248d4ed53cb1f1e490599.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/test-step-1.svg
// module id = 485
// module chunks = 0